/**
 * Qué versión es esta.
 *
 * Los dos valores los inyecta Vite al compilar (ver `vite.config.ts`) desde el
 * `package.json` de la raíz, que es de donde el APK saca también su
 * `versionName`. Una sola fuente para las dos, porque cuando cada uno tenía la
 * suya acabaron diciendo cosas distintas y preguntar la versión dejó de servir.
 */

declare const __VERSION__: string;
declare const __COMMIT__: string;

export const VERSION = __VERSION__;

/** Vacío si se compiló sin repositorio a mano; entonces solo hay versión. */
export const COMMIT = __COMMIT__;

/** `1.3.0 · a1b2c3d`, o solo `1.3.0` si no hubo repositorio. */
export function versionLarga(): string {
  return COMMIT ? `${VERSION} · ${COMMIT}` : VERSION;
}
